import problemData from '../repository/data/problem.json'

const VERIFICATION_CATEGORY = 'VERIFIKASI'

const toCategoryOption = (problem) => ({
  value: problem.problem_category,
  text: problem.problem_category,
})

export const getProblemCategoriesFromJson = () =>
  problemData.map(toCategoryOption)

export const getVerificationProblemCategories = () =>
  problemData
    // .filter((problem) => problem.problem_category === VERIFICATION_CATEGORY)
    .map(toCategoryOption)

export const getValidationProblemCategories = () =>
  problemData
    // .filter((problem) => problem.problem_category !== VERIFICATION_CATEGORY)
    .map(toCategoryOption)

export const getProblemIdentificationsFromJson = (problemCategory) => {
  const problem = problemData.find(
    (item) => item.problem_category === problemCategory
  )

  return problem
    ? problem.items.map((item) => ({
        value: item.value,
        text: item.label,
      }))
    : null
}
